<template>
    <typo :name="`${fontSize || 'body-14-light'}`" class="badge">
        <slot></slot>
    </typo>
</template>

<script>
export default {
    props: ["fontSize"],
};
</script>

<style lang="sass" scoped>
.badge
    display: inline-block
    border: 1px solid $color-secondary
    border-radius: 4px
    padding: 4px 12px
    margin: 4px 1px
    width: fit-content
</style>
